module.exports = __webpack_public_path__ + "img/image_part_002.f7881c0c.jpg";